import React from 'react'
import { useQuery } from '@apollo/client'
import Dialog from 'components/dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import Typography from '@material-ui/core/Typography'
import LinearProgress from '@material-ui/core/LinearProgress'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import LaunchOutlinedIcon from '@material-ui/icons/LaunchOutlined'
import { PAYMENT_ACCOUNT_LINK_SETUP } from './queries'
import { amplitudeEvent } from 'lib/amplitude'

const ManageStripeAccountConfirmationDialog = ({
  paymentAccount,
  isOpen,
  onClose,
}) => {
  const { detailsSubmitted, id } = paymentAccount || {}
  const { data, loading, error } = useQuery(PAYMENT_ACCOUNT_LINK_SETUP, {
    variables: {
      accountId: id,
      returnUrl: window.location.href,
    },
    skip: detailsSubmitted || !isOpen,
  })
  if (loading) return <LinearProgress />
  if (error) return <Typography color="error">Error loading data</Typography>

  const accountLink = data?.paymentAccountLinkSetup?.accountLink

  return (
    <Dialog isOpen={isOpen} maxWidth="xs" onClose={onClose} showCloseButton>
      {({ closeDialog }) => {
        const launchStripe = () => {
          if (!detailsSubmitted) {
            amplitudeEvent('resumed-payment-account-onboarding', {
              payment_account_name: paymentAccount.name,
              source: 'Coach',
              url: window.location.href,
              path: window.location.pathname,
            })
            window.open(accountLink)
          } else {
            amplitudeEvent('managed-payment-account', {
              payment_account_name: paymentAccount.name,
              source: 'Coach',
              url: window.location.href,
              path: window.location.pathname,
            })
            window.open(paymentAccount.manageUrl)
          }
          closeDialog()
        }
        return (
          <>
            <DialogTitle>Manage Stripe Account?</DialogTitle>
            <DialogContent dividers>
              <Typography variant="body1" align="center">
                Making any changes will affect each of the connections you have
                to this Stripe account.
              </Typography>
              <Box display="flex" justifyContent="flex-end" mt={2}>
                <Box mr={2}>
                  <Button color="primary" onClick={closeDialog}>
                    Cancel
                  </Button>
                </Box>
                <Button
                  color="primary"
                  variant="contained"
                  disabled={!detailsSubmitted && !accountLink}
                  onClick={launchStripe}
                >
                  Manage&nbsp;
                  <LaunchOutlinedIcon fontSize="small" />
                </Button>
              </Box>
            </DialogContent>
          </>
        )
      }}
    </Dialog>
  )
}

export default ManageStripeAccountConfirmationDialog
